import rangy from 'rangy';
import 'rangy/lib/rangy-classapplier';

import Utilities from './Utilities';
import key from './key'
import Emojis from '../../components/Emoji/emojis';

export default (function (w, d) {

    'use strict';

    var Medium = (function () {

        var Medium = function (userSettings) {
            "use strict";

            var medium = this,
                cache = new Medium.Cache(),
                selection = new Medium.Selection(),
                defaultSettings = utils.deepExtend({}, Medium.defaultSettings),
                settings = this.settings = utils.deepExtend(defaultSettings, userSettings),
                action = new Medium.Action(this),
                cursor = new Medium.Cursor(this),
                el,
                newVal,
                i;

            for (i in defaultSettings) if (defaultSettings.hasOwnProperty(i)) {
                // Override defaults with data-attributes
                if (
                    typeof defaultSettings[i] !== 'object'
                    && defaultSettings.hasOwnProperty(i)
                    && settings.element.getAttribute('data-medium-' + key)
                ) {
                    newVal = settings.element.getAttribute('data-medium-' + key);

                    if (newVal.toLowerCase() === "false" || newVal.toLowerCase() === "true") {
                        newVal = newVal.toLowerCase() === "true";
                    }
                    settings[i] = newVal;
                }
            }

            if (settings.modifiers) {
                for (i in settings.modifiers) if (settings.modifiers.hasOwnProperty(i)) {
                    if (typeof (key[i]) !== 'undefined') {
                        settings.modifiers[key[i]] = settings.modifiers[i];
                    }
                }
            }

            if (settings.keyContext) {
                for (i in settings.keyContext) if (settings.keyContext.hasOwnProperty(i)) {
                    if (typeof (key[i]) !== 'undefined') {
                        settings.keyContext[key[i]] = settings.keyContext[i];
                    }
                }
            }

            // Extend Settings
            el = settings.element;

            // Editable
            el.contentEditable = true;
            el.className
                += (' ' + settings.cssClasses.editor)
                + (' ' + settings.cssClasses.editor + '-' + settings.mode);

            settings.tags = (settings.tags || {});
            if (settings.tags.outerLevel) {
                settings.tags.outerLevel = settings.tags.outerLevel.concat([settings.tags.paragraph, settings.tags.horizontalRule]);
            }

            this.settings = settings;
            this.element = el;
            el.medium = this;

            this.action = action;
            this.cache = cache;
            this.cursor = cursor;
            this.utils = utils;
            this.selection = selection;

            // Initialize editor
            medium.clean();
            medium.placeholders();
            action.preserveElementFocus();

            this.dirty = false;

            if (settings.drag) {
                medium.drag = new Medium.Drag(medium);
                medium.drag.setup();
            }

            action.setup();

            // Set as initialized
            cache.initialized = true;

        };

        /** __PROTO__ */
        Medium.prototype = {
            placeholders: function () {
                //in IE8, just gracefully degrade to no placeholders
                if (!w.getComputedStyle) return;

                var s = this.settings,
                    placeholder = this.placeholder || (this.placeholder = d.createElement('div')),
                    el = this.element,
                    style = placeholder.style,
                    elStyle = w.getComputedStyle(el, null),
                    qStyle = function (prop) {
                        return elStyle.getPropertyValue(prop)
                    },
                    text = utils.text(el),
                    cursor = this.cursor,
                    childCount = el.children.length,
                    hasFocus = Medium.activeElement === el;

                el.placeholder = placeholder;

                // Empty Editor
                if (
                    !hasFocus
                    && text.length < 1
                    && childCount < 2
                ) {
                    if (el.placeHolderActive) return;

                    if (!el.innerHTML.match('<' + s.tags.paragraph)) {
                        el.innerHTML = '';
                    }

                    // We need to add placeholders
                    if (s.placeholder.length > 0) {
                        if (!placeholder.setup) {
                            placeholder.setup = true;

                            //background & background color
                            style.background = qStyle('background');
                            style.backgroundColor = qStyle('background-color');

                            //text size & text color
                            style.fontSize = qStyle('font-size');
                            style.color = elStyle.color;

                            //begin box-model
                            //margin
                            style.marginTop = qStyle('margin-top');
                            style.marginBottom = qStyle('margin-bottom');
                            style.marginLeft = qStyle('margin-left');
                            style.marginRight = qStyle('margin-right');

                            //padding
                            style.paddingTop = qStyle('padding-top');
                            style.paddingBottom = qStyle('padding-bottom');
                            style.paddingLeft = qStyle('padding-left');
                            style.paddingRight = qStyle('padding-right');

                            //border
                            style.borderTopWidth = qStyle('border-top-width');
                            style.borderTopColor = qStyle('border-top-color');
                            style.borderTopStyle = qStyle('border-top-style');
                            style.borderBottomWidth = qStyle('border-bottom-width');
                            style.borderBottomColor = qStyle('border-bottom-color');
                            style.borderBottomStyle = qStyle('border-bottom-style');
                            style.borderLeftWidth = qStyle('border-left-width');
                            style.borderLeftColor = qStyle('border-left-color');
                            style.borderLeftStyle = qStyle('border-left-style');
                            style.borderRightWidth = qStyle('border-right-width');
                            style.borderRightColor = qStyle('border-right-color');
                            style.borderRightStyle = qStyle('border-right-style');
                            //end box model

                            //element setup
                            placeholder.className = s.cssClasses.placeholder + ' ' + s.cssClasses.placeholder + '-' + s.mode;
                            placeholder.innerHTML = '<div>' + s.placeholder + '</div>';
                            el.parentNode.insertBefore(placeholder, el);
                        }

                        el.className += ' ' + s.cssClasses.clear;

                        style.display = '';
                        // Add base P tag and do auto focus, give it a min height if el has one
                        style.minHeight = el.clientHeight + 'px';
                        style.minWidth = el.clientWidth + 'px';

                        if (s.mode !== Medium.inlineMode && s.mode !== Medium.inlineRichMode) {
                            this.setupContents();

                            if (childCount === 0 && el.firstChild) {
                                cursor.set(this, 0, el.firstChild);
                            }
                        }
                    }
                    el.placeHolderActive = true;
                } else if (el.placeHolderActive) {
                    el.placeHolderActive = false;
                    style.display = 'none';
                    el.className = utils.trim(el.className.replace(s.cssClasses.clear, ''));
                    this.setupContents();
                }
            },

            /**
             * Cleans element
             * @arg {HtmlElement} [el] default is settings.element
             */
            clean: function (el) {
                /*
                 * Deletes invalid nodes
                 * Removes Attributes
                 */
                var s = this.settings,
                    placeholderClass = s.cssClasses.placeholder,
                    attributesToRemove = (s.attributes || {}).remove || [],
                    tags = s.tags || {},
                    onlyOuter = tags.outerLevel || null,
                    onlyInner = tags.innerLevel || null,
                    outerSwitch = {},
                    innerSwitch = {},
                    paragraphTag = (tags.paragraph || '').toUpperCase(),
                    html = this.html,
                    attr,
                    text,
                    j;

                el = el || s.element;

                if (s.mode === Medium.inlineRichMode) {
                    onlyOuter = s.tags.innerLevel;
                }

                if (onlyOuter !== null) {
                    for (j = 0; j < onlyOuter.length; j++) {
                        outerSwitch[onlyOuter[j].toUpperCase()] = true;
                    }
                }

                if (onlyInner !== null) {
                    for (j = 0; j < onlyInner.length; j++) {
                        innerSwitch[onlyInner[j].toUpperCase()] = true;
                    }
                }

                utils.traverseAll(el, {
                    element: function (child, i, depth, parent) {
                        var nodeName = child.nodeName,
                            shouldDelete = true,
                            attrValue;

                        // Remove attributes
                        for (j = 0; j < attributesToRemove.length; j++) {
                            attr = attributesToRemove[j];
                            if (child.hasAttribute(attr)) {
                                attrValue = child.getAttribute(attr);
                                if (attrValue !== placeholderClass && (!attrValue.match('medium-') && attr === 'class')) {
                                    child.removeAttribute(attr);
                                }
                            }
                        }

                        if (onlyOuter === null && onlyInner === null) {
                            return;
                        }

                        if (depth === 1 && outerSwitch[nodeName] !== undefined) {
                            shouldDelete = false;
                        } else if (depth > 1 && innerSwitch[nodeName] !== undefined) {
                            shouldDelete = false;
                        }

                        // Convert tags or delete
                        if (shouldDelete) {
                            if (w.getComputedStyle(child, null).getPropertyValue('display') === 'block') {
                                if (paragraphTag.length > 0 && paragraphTag !== nodeName) {
                                    utils.changeTag(child, paragraphTag);
                                }

                                if (depth > 1) {
                                    while (parent.childNodes.length > i) {
                                        parent.parentNode.insertBefore(parent.lastChild, parent.nextSibling);
                                    }
                                }
                            } else {
                                switch (nodeName) {
                                    case 'BR':
                                        if (child === child.parentNode.lastChild) {
                                            if (child === child.parentNode.firstChild) {
                                                break;
                                            }
                                            text = d.createTextNode("");
                                            text.innerHTML = '&nbsp';
                                            child.parentNode.insertBefore(text, child);
                                            break;
                                        }
                                    default:
                                        while (child.firstChild !== null) {
                                            child.parentNode.insertBefore(child.firstChild, child);
                                        }
                                        utils.detachNode(child);
                                        break;
                                }
                            }
                        }
                    }
                });
            },
            /**
             *
             * @arg {String|Object} html
             * @arg {Function} [callback]
             * @arg {Boolean} [skipChangeEvent]
             * @returns {Medium}
             */
            insertHtml: function (html, callback, skipChangeEvent) {
                var result = (new Medium.Html(this, html))
                    .insert(this.settings.beforeInsertHtml),
                    lastElement = result[result.length - 1];

                if (skipChangeEvent === true) {
                    utils.triggerEvent(this.element, "change");
                }

                switch (lastElement.nodeName) {
                    //lists need their last child selected if it exists
                    case 'UL':
                    case 'OL':
                    case 'DL':
                        if (lastElement.lastChild !== null) {
                            this.cursor.moveCursorToEnd(lastElement.lastChild);
                            break;
                        }
                    default:
                        this.cursor.moveCursorToEnd(lastElement);
                }

                if (callback) {
                    callback.apply(result);
                }

                return this;
            },

            addTag: function (tag, shouldFocus, isEditable, afterElement) {
                if (!this.settings.beforeAddTag(tag, shouldFocus, isEditable, afterElement)) {
                    var newEl = d.createElement(tag),
                        toFocus;

                    if (typeof isEditable !== "undefined" && isEditable === false) {
                        newEl.contentEditable = false;
                    }
                    if (newEl.innerHTML.length == 0) {
                        newEl.innerHTML = ' ';
                    }
                    if (afterElement && afterElement.nextSibling) {
                        afterElement.parentNode.insertBefore(newEl, afterElement.nextSibling);
                        toFocus = afterElement.nextSibling;

                    } else {
                        this.element.appendChild(newEl);
                        toFocus = this.lastChild();
                    }

                    if (shouldFocus) {
                        this.cache.focusedElement = toFocus;
                        this.cursor.set(this, 0, toFocus);
                    }
                    return newEl;
                }
                return null;
            },

            /**
             *
             * @arg {String} tagName
             * @arg {Object} [attributes]
             * @arg {Boolean} [skipChangeEvent]
             * @returns {Medium}
             */
            invokeElement: function (tagName, attributes, skipChangeEvent) {
                var settings = this.settings,
                    remove = attributes.remove || [];

                attributes = attributes || {};

                switch (settings.mode) {
                    case Medium.inlineMode:
                    case Medium.partialMode:
                        return this;
                    default:
                }

                //invoke works off class, so if it isn't there, we just add it
                if (remove.length > 0) {
                    if (!utils.arrayContains(settings, 'class')) {
                        remove.push('class');
                    }
                }

                (new Medium.Element(this, tagName, attributes))
                    .invoke(this.settings.beforeInvokeElement);

                if (skipChangeEvent === true) {
                    utils.triggerEvent(this.element, "change");
                }

                return this;
            },

            /**
             *
             * @arg {String} [value]
             * @returns {Medium}
             */
            value: function (value) {
                if (typeof value !== 'undefined') {
                    this.element.innerHTML = value;

                    this.clean();
                    this.placeholders();

                } else {
                    return this.element.innerHTML;
                }

                return this;
            },

            /**
             * Focus on element
             * @returns {Medium}
             */
            focus: function () {
                var el = this.element;
                el.focus();
                return this;
            },

            /**
             * Select all text
             * @returns {Medium}
             */
            select: function () {
                utils.selectNode(Medium.activeElement = this.element);
                return this;
            },

            isActive: function () {
                return (Medium.activeElement === this.element);
            },

            setupContents: function () {
                var el = this.element,
                    children = el.children,
                    childNodes = el.childNodes,
                    initialParagraph,
                    s = this.settings;

                if (
                    !s.tags.paragraph
                    || children.length > 0
                    || s.mode === Medium.inlineMode
                    || s.mode === Medium.inlineRichMode
                ) {
                    return Medium.Utilities;
                }

                //has content, but no children
                if (childNodes.length > 0) {
                    initialParagraph = d.createElement(s.tags.paragraph);
                    if (el.innerHTML.match('^[&]nbsp[;]')) {
                        el.innerHTML = el.innerHTML.substring(6, el.innerHTML.length - 1);
                    }
                    initialParagraph.innerHTML = el.innerHTML;
                    el.innerHTML = '';
                    el.appendChild(initialParagraph);
                    //this.cursor.set(this, initialParagraph.innerHTML.length, initialParagraph);
                } else {
                    initialParagraph = d.createElement(s.tags.paragraph);
                    initialParagraph.innerHTML = '&nbsp;';
                    el.appendChild(initialParagraph);
                    this.cursor.set(this, 0, el.firstChild);
                }

                return this;
            },

            destroy: function () {
                var el = this.element,
                    settings = this.settings,
                    placeholder = this.placeholder || null;

                if (placeholder !== null && placeholder.setup && placeholder.parentNode !== null) {
                    //remove placeholder
                    placeholder.parentNode.removeChild(placeholder);
                    delete el.placeHolderActive;
                }

                //remove contenteditable
                el.removeAttribute('contenteditable');

                //remove classes
                el.className = utils.trim(el.className
                    .replace(settings.cssClasses.editor, '')
                    .replace(settings.cssClasses.clear, '')
                    .replace(settings.cssClasses.editor + '-' + settings.mode, ''));

                //remove events
                this.action.destroy();

                if (this.settings.drag) {
                    this.drag.destroy();
                }
            },

            // Clears the element and restores the placeholder
            clear: function () {
                this.element.innerHTML = '';
                this.placeholders();
            },

            /**
             * Splits content in medium element at cursor
             * @returns {DocumentFragment|null}
             */
            splitAtCaret: function () {
                if (!this.isActive()) return null;

                var selector = (w.getSelection || d.selection),
                    sel = selector(),
                    offset = sel.focusOffset,
                    node = sel.focusNode,
                    el = this.element,
                    range = d.createRange(),
                    endRange = d.createRange(),
                    contents;

                range.setStart(node, offset);
                endRange.selectNodeContents(el);
                range.setEnd(endRange.endContainer, endRange.endOffset);

                contents = range.extractContents();

                return contents;
            },

            /**
             * Deletes selection
             */
            deleteSelection: function () {
                if (!this.isActive()) return;

                var sel = rangy.getSelection(),
                    range;

                if (sel.rangeCount > 0) {
                    range = sel.getRangeAt(0);
                    range.deleteContents();
                }
            },

            lastChild: function () {
                return this.element.lastChild;
            },

            bold: function () {

                switch (this.settings.mode) {
                    case Medium.partialMode:
                    case Medium.inlineMode:
                        return this;
                }

                (new Medium.Element(this, 'bold'))
                    .setClean(false)
                    .invoke(this.settings.beforeInvokeElement);

                return this;
            },
            underline: function () {
                switch (this.settings.mode) {
                    case Medium.partialMode:
                    case Medium.inlineMode:
                        return this;
                }

                (new Medium.Element(this, 'underline'))
                    .setClean(false)
                    .invoke(this.settings.beforeInvokeElement);

                return this;
            },
            italicize: function () {
                switch (this.settings.mode) {
                    case Medium.partialMode:
                    case Medium.inlineMode:
                        return this;
                }

                (new Medium.Element(this, 'italic'))
                    .setClean(false)
                    .invoke(this.settings.beforeInvokeElement);

                return this;
            },
            quote: function () {

                return this;
            },
            /**
             *
             * @arg {String} [text]
             * @returns {boolean}
             */
            paste: function (text) {
                var value = this.value(),
                    length = value.length,
                    totalLength,
                    settings = this.settings,
                    selection = this.selection,
                    el = this.element,
                    medium = this,
                    postPaste = function (text) {
                        text = text || '';
                        if (text.length > 0) {
                            el.focus();
                            Medium.activeElement = el;
                            selection.restoreSelection(sel);

                            //encode the text first
                            text = utils.encodeHtml(text);

                            //cut down it's length
                            totalLength = text.length + length;
                            if (settings.maxLength > 0 && totalLength > settings.maxLength) {
                                text = text.substring(0, settings.maxLength - length);
                            }

                            if (settings.mode !== Medium.inlineMode) {
                                text = text.replace(/\n/g, '<br>');
                            }

                            (new Medium.Html(medium, text))
                                .setClean(false)
                                .insert(settings.beforeInsertHtml, true);

                            medium.clean();
                            medium.placeholders();
                        }
                    };

                if (text !== undefined) {
                    postPaste(text);
                } else if (settings.pasteAsText) {
                    var sel = selection.saveSelection();

                    utils.pasteHook(this, postPaste);
                } else {
                    setTimeout(function () {
                        medium.clean();
                        medium.placeholders();
                    }, 20);
                }
                return true;
            }
        };

        /** Modes */
        Medium.inlineMode = 'inline';
        Medium.partialMode = 'partial';
        Medium.richMode = 'rich';
        Medium.inlineRichMode = 'inlineRich';
        Medium.Messages = {
            pastHere: 'Paste Here'
        };

        /** Default Settings */
        Medium.defaultSettings = {
            element: null,
            modifier: 'auto',
            placeholder: "",
            autofocus: false,
            autoHR: true,
            mode: Medium.richMode,
            maxLength: -1,
            modifiers: {
                'b': 'bold',
                'i': 'italicize',
                'u': 'underline'
            },
            tags: {
                'break': 'br',
                'horizontalRule': 'hr',
                'paragraph': 'p',
                'outerLevel': ['pre', 'blockquote', 'figure'],
                'innerLevel': ['a', 'b', 'u', 'i', 'img', 'strong']
            },
            cssClasses: {
                editor: 'Medium',
                pasteHook: 'Medium-paste-hook',
                placeholder: 'Medium-placeholder',
                clear: 'Medium-clear'
            },
            attributes: {
                remove: ['style', 'class']
            },
            pasteAsText: true,
            beforeInvokeElement: function () {
                //this = Medium.Element
            },
            beforeInsertHtml: function () {
                //this = Medium.Html
            },
            maxLengthReached: function (element) {
                //element
            },
            beforeAddTag: function (tag, shouldFocus, isEditable, afterElement) {
            },
            onBlur: function () { },
            onFocus: function () { },
            keyContext: null,
            drag: false
        };

        /** Cache */
        (function (Medium) {
            "use strict";

            Medium.Cache = function () {
                this.initialized = false;
                this.cmd = false;
                this.focusedElement = null;
                this.originalVal = null;
            };
        })(Medium);

        /** Selection */
        (function (Medium) {
            "use strict";

            Medium.Selection = function () {

            };
            Medium.Selection.prototype = {
                saveSelection: function () {
                    if (w.getSelection) {
                        var sel = w.getSelection();
                        if (sel.rangeCount > 0) {
                            return sel.getRangeAt(0);
                        }
                    } else if (d.selection && d.selection.createRange) { // IE
                        return d.selection.createRange();
                    }
                    return null;
                },

                restoreSelection: function (range) {
                    if (range) {
                        if (w.getSelection) {
                            var sel = w.getSelection();
                            sel.removeAllRanges();
                            sel.addRange(range);
                        } else if (d.selection && range.select) { // IE
                            range.select();
                        }
                    }
                }
            };
        })(Medium);

        /** Action */
        (function (Medium, w, d) {
            "use strict";

            function isEditable(e) {
                e = e || w.event
                if (e.hasOwnProperty('target') && e.target.getAttribute('contenteditable') === 'false') {
                    utils.preventDefaultEvent(e);
                    return false;
                }
                return true;
            }

            Medium.Action = function (medium) {
                this.medium = medium;

                this.handledEvents = {
                    keydown: null,
                    keyup: null,
                    blur: null,
                    focus: null,
                    paste: null,
                    click: null
                };

            };
            Medium.Action.prototype = {
                setup: function () {
                    this
                        .handleFocus()
                        .handleBlur()
                        .handleKeyDown()
                        .handleKeyUp()
                        .handlePaste()
                        .handleClick();
                },
                destroy: function () {
                    var el = this.medium.element;

                    utils
                        .removeEvent(el, 'focus', this.handledEvents.focus)
                        .removeEvent(el, 'blur', this.handledEvents.blur)
                        .removeEvent(el, 'keydown', this.handledEvents.keydown)
                        .removeEvent(el, 'keyup', this.handledEvents.keyup)
                        .removeEvent(el, 'paste', this.handledEvents.paste)
                        .removeEvent(el, 'click', this.handledEvents.click);
                },
                handleFocus: function () {

                    var medium = this.medium,
                        el = medium.element;

                    utils.addEvent(el, 'focus', this.handledEvents.focus = function (e) {
                        e = e || w.event;

                        if (!isEditable(e)) {
                            return false;
                        }

                        Medium.activeElement = el;
                        medium.cache.originalVal = e.target.textContent;
                        medium.settings.onFocus(e);

                        medium.placeholders();
                    });

                    return this;
                },
                handleBlur: function () {

                    var medium = this.medium,
                        el = medium.element;

                    utils.addEvent(el, 'blur', this.handledEvents.blur = function (e) {
                        e = e || w.event;

                        if (Medium.activeElement === el) {
                            Medium.activeElement = null;
                        }

                        medium.settings.onBlur(e);
                        medium.placeholders();
                    });

                    return this;
                },
                handleKeyDown: function () {

                    var action = this,
                        medium = this.medium,
                        settings = medium.settings,
                        cache = medium.cache,
                        el = medium.element;

                    utils.addEvent(el, 'keydown', this.handledEvents.keydown = function (e) {
                        e = e || w.event;

                        if (!isEditable(e)) {
                            return false;
                        }

                        var keepEvent = true;

                        //in Chrome it sends out this event before every regular event, not sure why
                        if (e.keyCode === 229) return;

                        utils.isCommand(settings, e, function () {
                            cache.cmd = true;
                        }, function () {
                            cache.cmd = false;
                        });

                        utils.isShift(e, function () {
                            cache.shift = true;
                        }, function () {
                            cache.shift = false;
                        });

                        utils.isModifier(settings, e, function (cmd) {
                            e = e || w.event

                            if (cache.cmd) {

                                if ((settings.mode === Medium.inlineMode) || (settings.mode === Medium.partialMode)) {
                                    utils.preventDefaultEvent(e);
                                    return false;
                                }

                                var cmdType = typeof cmd;
                                var fn = null;
                                if (cmdType === "function") {
                                    fn = cmd;
                                } else {
                                    fn = medium[cmd];
                                }

                                keepEvent = fn.call(medium, e);

                                if (keepEvent === false || keepEvent === medium) {
                                    utils.preventDefaultEvent(e);
                                    utils.stopPropagation(e);
                                }
                                return true;
                            }
                            return false;
                        });

                        if (settings.maxLength !== -1) {
                            var len = utils.text(el).length,
                                hasSelection = false,
                                selection = w.getSelection(),
                                isSpecial = utils.isSpecial(e),
                                isNavigational = utils.isNavigational(e);

                            if (selection) {
                                hasSelection = !selection.isCollapsed;
                            }

                            if (isSpecial || isNavigational) {
                                return true;
                            }

                            if (len >= settings.maxLength && !hasSelection) {
                                settings.maxLengthReached(el);
                                utils.preventDefaultEvent(e);
                                return false;
                            }
                        }

                        switch (e.keyCode) {
                            case key['enter']:
                                if (action.enterKey(e) === false) {
                                    utils.preventDefaultEvent(e);
                                }
                                break;
                            case key['escape']:
                                if (action.escKey(e) === false) {
                                    utils.preventDefaultEvent(e);
                                }
                                break;
                            case key['backspace']:
                            case key['delete']:
                                action.backspaceOrDeleteKey(e);
                                break;
                        }

                        return keepEvent;
                    }); //

                    return this;
                },
                handleKeyUp: function () {

                    var action = this,
                        medium = this.medium,
                        settings = medium.settings,
                        cache = medium.cache,
                        cursor = medium.cursor,
                        el = medium.element;

                    utils.addEvent(el, 'keyup', this.handledEvents.keyup = function (e) {
                        e = e || w.event;

                        if (!isEditable(e)) {
                            return false;
                        }

                        utils.isCommand(settings, e, function () {
                            cache.cmd = false;
                        }, function () {
                            cache.cmd = true;
                        });
                        medium.clean();
                        medium.placeholders();

                        //here we have a key context, so if you need to create your own object within a specific context it is doable
                        var keyContext;
                        if (
                            settings.keyContext !== null
                            && (keyContext = settings.keyContext[e.keyCode])
                        ) {
                            var el = cursor.parent();

                            if (el) {
                                keyContext.call(medium, e, el);
                            }
                        }

                        action.preserveElementFocus();
                    });

                    return this;
                },
                handlePaste: function () {
                    var medium = this.medium,
                        el = medium.element,
                        text,
                        i,
                        max,
                        data,
                        cD,
                        type,
                        types;

                    utils.addEvent(el, 'paste', this.handledEvents.paste = function (e) {
                        e = e || w.event;

                        if (!isEditable(e)) {
                            return false;
                        }

                        i = 0;
                        utils.preventDefaultEvent(e);
                        text = '';
                        cD = e.clipboardData;

                        if (cD && (data = cD.getData)) {
                            types = cD.types;
                            max = types.length;
                            for (i = 0; i < max; i++) {
                                type = types[i];
                                switch (type) {
                                    //case 'text/html':
                                    //	return medium.paste(cD.getData('text/html'));
                                    case 'text/plain':
                                        return medium.paste(cD.getData('text/plain'));
                                }
                            }
                        }

                        medium.paste();
                    });

                    return this;
                },
                handleClick: function () {
                    var medium = this.medium,
                        el = medium.element,
                        cursor = medium.cursor;

                    utils.addEvent(el, 'click', this.handledEvents.click = function (e) {
                        if (!isEditable(e)) {
                            cursor.caretToAfter(e.target);
                        }

                    });

                    return this;
                },
                escKey: function (e) {
                    var medium = this.medium,
                        el = medium.element,
                        settings = medium.settings,
                        cache = medium.cache;

                    if (settings.mode === Medium.inlineMode || settings.mode === Medium.inlineRichMode) {
                        e.target.textContent = cache.originalVal;

                        if (settings.element.blur) {
                            settings.element.blur();
                        } else if (settings.element.onblur) {
                            settings.element.onblur();
                        }
                        return false;
                    }
                },
                enterKey: function (e) {
                    var medium = this.medium,
                        el = medium.element,
                        settings = medium.settings,
                        cache = medium.cache,
                        cursor = medium.cursor;

                    if (settings.mode === Medium.inlineMode || settings.mode === Medium.inlineRichMode) {
                        if (settings.element.blur) {
                            settings.element.blur();
                        } else if (settings.element.onblur) {
                            settings.element.onblur();
                        }
                        return false;
                    }

                    if (cache.shift) {
                        if (settings.tags['break']) {
                            medium.addTag(settings.tags['break'], true);
                            return false;
                        }

                    } else {

                        var focusedElement = utils.atCaret(medium) || {},
                            children = el.children,
                            lastChild = focusedElement === el.lastChild ? el.lastChild : null,
                            makeHR,
                            secondToLast,
                            paragraph;

                        if (
                            lastChild
                            && lastChild !== el.firstChild
                            && settings.autoHR
                            && settings.mode !== Medium.partialMode
                            && settings.tags.horizontalRule
                        ) {

                            utils.preventDefaultEvent(e);

                            makeHR =
                                utils.text(lastChild) === ""
                                && lastChild.nodeName.toLowerCase() === settings.tags.paragraph;

                            if (makeHR && children.length >= 2) {
                                secondToLast = children[children.length - 2];

                                if (secondToLast.nodeName.toLowerCase() === settings.tags.horizontalRule) {
                                    makeHR = false;
                                }
                            }

                            if (makeHR) {
                                medium.addTag(settings.tags.horizontalRule, false, true, focusedElement);
                                focusedElement = focusedElement.nextSibling;
                            }

                            if ((paragraph = medium.addTag(settings.tags.paragraph, true, null, focusedElement)) !== null) {
                                paragraph.innerHTML = '';
                                cursor.set(medium, 0, paragraph);
                            }
                        }
                    }

                    return true;
                },
                backspaceOrDeleteKey: function (e) {
                    var medium = this.medium,
                        cursor = medium.cursor,
                        settings = medium.settings,
                        el = medium.element;

                    if (settings.onBackspaceOrDelete !== undefined) {
                        var result = settings.onBackspaceOrDelete.call(medium, e, el);

                        if (result) {
                            return;
                        }
                    }


                    if (el.lastChild === null) return;


                    var lastChild = el.lastChild,
                        beforeLastChild = lastChild.previousSibling,
                        anchorNode = rangy.getSelection().anchorNode;


                    if (
                        lastChild
                        && settings.tags.horizontalRule
                        && lastChild.nodeName.toLocaleLowerCase() === settings.tags.horizontalRule
                    ) {
                        el.removeChild(lastChild);

                    } else if (
                        lastChild
                        && beforeLastChild
                        && utils.text(lastChild).length < 1
                        && beforeLastChild.nodeName.toLowerCase() === settings.tags.horizontalRule
                        && lastChild.nodeName.toLowerCase() === settings.tags.paragraph
                    ) {
                        el.removeChild(lastChild);
                        el.removeChild(beforeLastChild);
                    } else if (
                        el.childNodes.length === 1
                        && lastChild
                        && !utils.text(lastChild).length
                    ) {
                        // utils.preventDefaultEvent(e);
                        medium.setupContents();
                    }
                    else if (lastChild &&
                        lastChild.hasAttribute &&
                        lastChild.getAttribute('contentEditable') === "false"
                    ) {
                        //
                    }
                    else if (anchorNode && anchorNode === el) {
                        medium.deleteSelection();
                        medium.setupContents();
                        cursor.set(medium, 0, el.firstChild);
                    }

                },

                preserveElementFocus: function () {
                    // Fetch node that has focus
                    var anchorNode = w.getSelection ? w.getSelection().anchorNode : document.activeElement;
                    if (anchorNode) {
                        var medium = this.medium,
                            cache = medium.cache,
                            el = medium.element,
                            s = medium.settings,
                            cur = anchorNode.parentNode,
                            children = el.children,
                            diff = cur !== cache.focusedElement,
                            elementIndex = 0,
                            i;

                        // anchorNode is our target if element is empty
                        if (cur === s.element) {
                            cur = anchorNode;
                        }

                        // Find our child index
                        for (i = 0; i < children.length; i++) {
                            if (cur === children[i]) {
                                elementIndex = i;
                                break;
                            }
                        }

                        // Focused element is different
                        if (diff) {
                            cache.focusedElement = cur;
                            cache.focusedElementIndex = elementIndex;
                        }
                    }
                }
            };

        })(Medium, w, d);

        /** Cursor */
        (function (Medium) {
            "use strict";
            /*
             * Handle Cursor Logic
             */
            Medium.Cursor = function (medium) {
                this.medium = medium;
            };
            Medium.Cursor.prototype = {
                set: function (pos, el) {
                    var range;

                    if (d.createRange) {
                        var selection = w.getSelection(),
                            lastChild = this.medium.lastChild(),
                            length = utils.text(lastChild).length - 1,
                            toModify = el ? el : lastChild,
                            theLength = ((typeof pos !== 'undefined') && (pos !== null) ? pos : length);

                        range = d.createRange();
                        range.setStart(toModify, theLength);
                        range.collapse(true);
                        selection.removeAllRanges();
                        selection.addRange(range);
                    } else {
                        range = d.body.createTextRange();
                        range.moveToElementText(el);
                        range.collapse(false);
                        range.select();
                    }
                },
                //http://davidwalsh.name/caret-end
                moveCursorToEnd: function (el) {
                    //get the browser selection object - it may or may not have a selected range
                    var selection = rangy.getSelection(),

                        //create a range object to set the caret positioning for
                        range = rangy.createRange();


                    //set the caret after the start node and at the end of the end node
                    //Note: the end is set using endNode.length when the node is of the text type
                    //and it is set using childNodes.length when the end node is of the element type
                    range.setStartAfter(el);
                    range.setEnd(el, el.length || el.childNodes.length);

                    //apply this range to the selection object
                    selection.removeAllRanges();
                    selection.addRange(range);
                },
                moveCursorToAfter: function (el) {
                    var sel = rangy.getSelection();
                    if (sel.rangeCount) {
                        var range = sel.getRangeAt(0);
                        range.collapse(false);
                        range.collapseAfter(el);
                        sel.setSingleRange(range);
                    }
                },
                parent: function () {
                    var target = null, range;

                    if (w.getSelection) {
                        range = w.getSelection().getRangeAt(0);
                        target = range.commonAncestorContainer;

                        target = (target.nodeType === 1
                            ? target
                            : target.parentNode
                        );
                    }

                    else if (d.selection) {
                        target = d.selection.createRange().parentElement();
                    }

                    if (target.tagName == 'SPAN') {
                        target = target.parentNode;
                    }

                    return target;
                },
                caretToBeginning: function (el) {
                    this.set(0, el);
                },
                caretToEnd: function (el) {
                    this.moveCursorToEnd(el);
                },
                caretToAfter: function (el) {
                    this.moveCursorToAfter(el);
                }
            };
        })(Medium);

        /** HTML */
        (function (Medium) {
            "use strict";

            /**
             * @constructor
             * @arg {Medium} medium
             * @arg {String|HtmlElement} html
             */
            Medium.Html = function (medium, html) {
                this.html = html;
                this.medium = medium;
                this.clean = true;
                this.injector = new Medium.Injector();
            };

            Medium.Html.prototype = {
                /**
                 * @methodOf Medium.Html
                 * @arg {Function} [fn]
                 * @arg {Boolean} [selectInserted]
                 * @returns {HtmlElement}
                 */
                insert: function (fn, selectInserted) {
                    if (Medium.activeElement === this.medium.element) {
                        if (fn) {
                            fn.apply(this);
                        }

                        var inserted = this.injector.inject(this.html, selectInserted);

                        if (this.clean) {
                            //cleanup
                            this.medium.clean();
                            this.medium.placeholders();
                        }


                        return inserted;
                    } else {
                        return null;
                    }
                },

                /**
                 * @methodOf Medium.Html
                 * @arg clean
                 * @returns {Medium.Html}
                 */
                setClean: function (clean) {
                    this.clean = clean;
                    return this;
                }
            };

        })(Medium);

        /** Injector */
        (function (Medium) {
            "use strict";

            /**
             *
             * @constructor
             */
            Medium.Injector = function () {
            };

            Medium.Injector.prototype = {
                /**
                 * @methodOf Medium.Injector
                 * @arg {String|HtmlElement} htmlRaw
                 * @returns {[HtmlElement|Node]}
                 */
                inject: function (htmlRaw) {
                    var nodes = [],
                        html,
                        isConverted = false;

                    if (typeof htmlRaw === 'string') {
                        var htmlConverter = d.createElement('div');
                        htmlConverter.innerHTML = htmlRaw;
                        html = htmlConverter.childNodes;
                        isConverted = true;
                    } else {
                        html = htmlRaw;
                    }

                    this.insertHTML('<span id="Medium-wedge"></span>');

                    var wedge = d.getElementById('Medium-wedge'),
                        parent = wedge.parentNode,
                        i = 0;

                    wedge.removeAttribute('id');

                    if (isConverted) {
                        //make an array of elements that are about to be inserted, can't use html because they will
                        while (i < html.length) {
                            nodes.push(html[i]);
                            i++;
                        }

                        while (html.length > 0) {
                            parent.insertBefore(html[0], wedge);
                        }
                    } else {
                        nodes.push(html);
                        parent.insertBefore(html, wedge);
                    }
                    parent.removeChild(wedge);
                    wedge = null;

                    return nodes;
                },

                //Thank you Tim Down (super uber genius): http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div/6691294#6691294
                insertHTML: function (html, selectPastedContent) {
                    var sel, range;
                    if (w.getSelection) {
                        // IE9 and non-IE
                        sel = w.getSelection();
                        if (sel.getRangeAt && sel.rangeCount) {
                            range = sel.getRangeAt(0);
                            range.deleteContents();

                            // Range.createContextualFragment() would be useful here but is
                            // only relatively recently standardized and is not supported in
                            // some browsers (IE9, for one)
                            var el = d.createElement("div");
                            el.innerHTML = html;
                            var frag = d.createDocumentFragment(), node, lastNode;
                            while ((node = el.firstChild)) {
                                lastNode = frag.appendChild(node);
                            }
                            var firstNode = frag.firstChild;
                            range.insertNode(frag);

                            // Preserve the selection
                            if (lastNode) {
                                range = range.cloneRange();
                                range.setStartAfter(lastNode);
                                if (selectPastedContent) {
                                    range.setStartBefore(firstNode);
                                } else {
                                    range.collapse(true);
                                }
                                sel.removeAllRanges();
                                sel.addRange(range);
                            }
                        }
                    } else if ((sel = d.selection) && sel.type != "Control") {
                        // IE < 9
                        var originalRange = sel.createRange();
                        originalRange.collapse(true);
                        sel.createRange().pasteHTML(html);
                        if (selectPastedContent) {
                            range = sel.createRange();
                            range.setEndPoint("StartToStart", originalRange);
                            range.select();
                        }
                    }
                }
            };
        })(Medium);

        /** Element */
        (function (Medium) {
            "use strict";

            /**
             * @arg {Medium} medium
             * @arg {String} tagName
             * @arg {Object} [attributes]
             * @constructor
             */
            Medium.Element = function (medium, tagName, attributes) {
                this.medium = medium;
                this.element = medium.element;

                switch (tagName.toLowerCase()) {
                    case 'bold':
                        this.tagName = 'b';
                        break;
                    case 'italic':
                        this.tagName = 'i';
                        break;
                    case 'underline':
                        this.tagName = 'u';
                        break;
                    default:
                        this.tagName = tagName;
                }

                this.attributes = attributes || {};
                this.clean = true;
            };

            Medium.Element.prototype = {
                /**
                 * @methodOf Medium.Element
                 * @arg {Function} [fn]
                 */
                invoke: function (fn) {
                    if (Medium.activeElement === this.element) {
                        if (fn) {
                            fn.apply(this);
                        }

                        var
                            attr = this.attributes,
                            tagName = this.tagName.toLowerCase(),
                            applier,
                            cl;

                        if (attr.className !== undefined) {
                            cl = (attr.className.split[' '] || [attr.className]).shift();
                            delete attr.className;
                        } else {
                            cl = 'medium-' + tagName;
                        }
                        applier = rangy.createClassApplier(cl, {
                            elementTagName: tagName,
                            elementAttributes: this.attributes
                        });

                        applier.toggleSelection(w);

                        if (this.clean) {
                            //cleanup
                            this.medium.clean();
                            this.medium.placeholders();
                        }


                    }
                },

                /**
                 *
                 * @arg {Boolean} clean
                 * @returns {Medium.Element}
                 */
                setClean: function (clean) {
                    this.clean = clean;
                    return this;
                }
            };
        })(Medium);

        Medium.Utilities = Utilities;

        rangy.rangePrototype.insertNodeAtEnd = function (node) {
            var range = this.cloneRange();
            range.collapse(false);
            range.insertNode(node);
            range.detach();
            this.setEndAfter(node);
        };

        return Medium

    }()),
        utils = Medium.Utilities,


























        Editor = (function () {


            var Editor = function (originalElement, options) {
                "use strict";

                this.editor = null;
                this.medium = null;
                this.originalElement = originalElement;
                var toolbar = new Editor.Toolbar(this, options);
                this.toolbar = toolbar;

                this.setup();
            };

            /** PROTO */
            Editor.prototype = {

                setup: function () {
                    // console.log(this.originalElement)
                    this.originalElement.style.display = 'none';
                    this.editor = utils.createElement('DIV', ['autocomplete-editor']);

                    this.originalElement.parentNode.insertBefore(this.editor, this.originalElement);

                    this.toolbar.setup();
                    this.toolbar.load();

                    var content = utils.createElement('DIV');
                    this.editor.appendChild(content);

                    this.editor.style.minHeight = (this.originalElement.hasAttribute('height') ? this.originalElement.getAttribute('height') : '2rem');

                    return this;
                },

                setParent: function (medium) {
                    this.medium = medium
                },

                element: function () {
                    return this.editor.childNodes[1]
                },

                value: function (value) {
                    this.cleanNodesEmpty();
                    return this.medium.value(value);
                },

                insertHtml: function (html) {
                    if (html) {

                        var me = this;
                        this.medium.focus();

                        this.medium.insertHtml(html, function () {
                            var lastElement = this[this.length - 1];

                            // console.log(lastElement);

                            switch (lastElement.nodeName) {
                                case 'UL':
                                case 'OL':
                                case 'DL':
                                    break;
                                default:
                                    me.medium.cursor.moveCursorToAfter(lastElement);
                            }
                            return false;
                        });
                    }
                },

                cleanNodesEmpty: function (node) {
                    var nodes = (node || this.medium.element).childNodes;

                    var i = nodes.length;

                    if (i--) do {
                        var nodeName = nodes[i].nodeName;

                        if (nodeName === "#text") {
                            // var template = utils.createElement('ul'),
                            //     li = utils.createElement('li');
                            // li.innerHTML = nodes[i].textContent;
                            // template.appendChild(li);
                            // template.setAttribute('type', 'block');
                            // nodes[i].parentNode.replaceChild(template, nodes[i]);
                        } else if (nodeName === "DIV") {
                            if (nodes[i].childNodes.length === 1 && nodes[i].childNodes[0].nodeName == "BR") {
                                nodes[i].parentNode.removeChild(nodes[i]);
                            } else {
                                this.cleanNodesEmpty(nodes[i]);
                            }
                        }
                    } while (i--);

                    return !true;
                },

            };

            /**Toolbar */
            (function (Editor) {
                "use strict";

                Editor.Toolbar = function (editor, options) {
                    this.editor = editor;
                    this.options = utils.deepExtend({}, options || {});
                };

                Editor.Toolbar.prototype = {

                    setup: function () {

                        var list = utils.createElement('UL', 'toolbar-list');
                        var dashboard = utils.createElement('DIV', 'toolbar-dashboard', 'display: none;');
                        var toolbar = utils.createElement('DIV', 'toolbar');

                        toolbar.appendChild(list);
                        toolbar.appendChild(dashboard);

                        this.editor.editor.appendChild(toolbar);

                        this.list = list;
                        this.dashboard = dashboard;
                        this.toolbar = toolbar;

                        this.setOptions();

                        return this;
                    },

                    setOptions: function (options) {
                        this.options = utils.deepExtend(this.options, options || {});
                        this.options = utils.deepExtend({
                            "@n": {
                                handlerName: 'handleNewBlock',
                                icon: 'fa-plus',
                                short_descroption: 'New Block',
                                status: (function (me) {
                                    if (me.editor.originalElement && me.editor.originalElement.hasAttribute('block-status') && me.editor.originalElement.getAttribute('block-status') == 'off') {
                                        return false;
                                    }
                                    return true;
                                }(this)),
                            },
                            "random": {
                                handlerName: 'handleRandom',
                                icon: this.randomIcon(),
                                short_descroption: 'Random',
                                status: (function (me) {
                                    if (me.editor.originalElement && me.editor.originalElement.hasAttribute('block-status') && me.editor.originalElement.getAttribute('block-status') == 'off') {
                                        return false;
                                    }
                                    return true;
                                }(this))
                            },
                            "@e": {
                                handlerName: 'handleDashboard',
                                icon: this.smileIcon(),
                                short_descroption: 'Emoji',
                                list: Emojis['Smileys &amp; People'],
                                status: (function (me) {
                                    if (me.editor.originalElement && me.editor.originalElement.hasAttribute('emoji-status') && me.editor.originalElement.getAttribute('emoji-status') == 'off') {
                                        return false;
                                    }
                                    return true;
                                }(this))
                            },
                        }, this.options);

                        for (var i in this.options) if (this.options.hasOwnProperty(i)) {
                            this.options[i].eventName = 'mousedown';
                            this.options[i].handlerName = this.options[i].handlerName || 'handleDashboard';
                            this.options[i].remove && this.options[i].remove();
                        }
                    },

                    load: function () {
                        var random, i;

                        this.list.innerHTML = '';

                        for (i in this.options) if (this.options.hasOwnProperty(i)) {
                            var option = this.options[i];

                            if (!option.hasOwnProperty('status') || option.status === true) {

                                var customClass = ((
                                    option.hasOwnProperty('list')
                                    && Array.isArray(option.list)
                                    && !option.list.length)
                                    ? 'toolbar-list-item-off'
                                    : '');

                                var element = utils.createElement('LI', ['toolbar-list-item'].concat(customClass || [])),
                                    elementLink = utils.createElement('A', 'toolbar-list-item-link'),
                                    elementLinkIcon,
                                    icon = option.icon;

                                if (icon) {
                                    if (icon.startsWith('<svg')) {
                                        var iconTemplate = utils.createElement('span');
                                        iconTemplate.innerHTML = icon;
                                        elementLinkIcon = iconTemplate.firstChild;
                                    } else {
                                        elementLinkIcon = utils.createElement('I', ['fa', icon])
                                    }
                                } else if (option.short_descroption) {
                                    elementLinkIcon = document.createTextNode(option.short_descroption)
                                }

                                if (option.short_descroption) {
                                    element.title = option.short_descroption
                                }

                                elementLink.appendChild(elementLinkIcon)

                                element.appendChild(elementLink)

                                option['element'] = element

                                if ("function" === typeof this[option.handlerName]) {

                                    utils.addEvent(
                                        element,
                                        this.options[i]['eventName'],
                                        this.options[i]['handler'] = this[this.options[i].handlerName].bind(this, { ...this.options[i], target: i })
                                    );

                                    this.options[i]['remove'] = function () {
                                        if (this.element && typeof this.element !== "undefined") {

                                            utils.removeEvent(
                                                this.element,
                                                this.eventName,
                                                this.handler
                                            );

                                            this.element.parentNode.removeChild(this.element);
                                            this.element = undefined;
                                            this.handler = undefined;
                                        }
                                    }.bind(this.options[i]);
                                }

                                this.list.appendChild(element);

                                if (option.handlerName === "handleRandom" &&
                                    this.editor.medium &&
                                    this.editor.medium.element) {
                                    if (random = this.editor.medium.element.querySelector('#random')) {
                                        random.setAttribute('status', parseInt(random.getAttribute('status')) === 0 ? 1 : 0);
                                        this.handleRandom();
                                    }
                                }

                            }
                        }

                        return this;
                    },

                    handleDashboard: function (props, e) {
                        e = e || w.event
                        var me = this,
                            i,
                            btn;

                        utils.preventDefaultEvent(e);

                        props.list = Array.isArray(props.list) ? props.list : (Object.prototype.toString.call(props.list) === '[object Object]' ? Object.values(props.list) : []);

                        function renderButtons() {
                            me.dashboard.innerHTML = '';
                            if (props.list.length) {
                                for (i = 0; i < props.list.length; i++) {
                                    btn = utils.createElement('BUTTON', 'toolbar-dashboard-btn');
                                    btn.setAttribute('type', 'button');
                                    btn.title = props.list[i];
                                    btn.innerText = props.list[i];
                                    me.dashboard.appendChild(btn);
                                    btn.onmousedown = me.handleDashBtnClick.bind(me, props);
                                }
                                utils.show(me.dashboard);
                            } else {
                                utils.hide(me.dashboard);
                            }
                        }

                        if (this.dashboard.style.display != 'none') {
                            if (this.dashboard.getAttribute('target') == props.target) {
                                utils.hide(this.dashboard);
                            } else {
                                renderButtons();
                            }
                        } else {
                            renderButtons();
                        }

                        this.dashboard.setAttribute('target', props.target);

                        return false;
                    },

                    handleNewBlock: function (props, e) {
                        e = e || w.event;
                        utils.preventDefaultEvent(e);

                        var lastChild = this.editor.medium.lastChild();

                        if (!lastChild || lastChild.tagName !== "UL") {

                            var template = utils.createElement('ul'),
                                li = utils.createElement('li');

                            li.innerHTML = '';

                            template.appendChild(li);
                            template.setAttribute('type', 'block');
                            this.editor.insertHtml(template);
                        }

                        return false;
                    },

                    handleRandom: function (props, e) {
                        e = e || w.event;

                        e && utils.preventDefaultEvent(e);

                        var icon = this.toolbar.querySelector('path'),
                            random;

                        if (random = this.editor.medium.element.querySelector('#random')) {
                            random.setAttribute('status', parseInt(random.getAttribute('status')) === 0 ? 1 : 0)
                        } else {
                            random = utils.createElement('div');
                            random.setAttribute('id', 'random');
                            random.setAttribute('status', 1);
                            this.editor.medium.element.appendChild(random);
                        }
                        if (icon) {
                            if (parseInt(random.getAttribute('status')) === 1) {
                                icon.setAttribute('fill', '#c2cfd6');
                            } else {
                                icon.setAttribute('fill', '#3e515b');
                            }
                        }

                        var value = this.editor.value().slice();

                        this.editor.originalElement.value = value;

                        utils.triggerEvent(this.editor.originalElement, 'input');
                    },

                    handleDashBtnClick: function (props, e) {
                        e = e || w.event;

                        utils.preventDefaultEvent(e);

                        utils.hide(this.dashboard);

                        var value = e.target.hasAttribute('value') ? e.target.getAttribute('value') : e.target.innerText,
                            template = utils.createElement('div'),
                            html = utils.highlight(props, value)

                        template.innerHTML = html;

                        this.editor.insertHtml(template.firstChild);

                        return false;
                    },

                    smileIcon: function () {
                        return '<svg aria-hidden="true" style=" width: 15px;" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="#3e515b" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"></path></svg>';
                    },
                    randomIcon: function () {
                        return '<svg aria-hidden="true" style=" width: 15px;" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path fill="#3e515b" d="M505 400l-79.2 72.9c-15.1 15.1-41.8 4.4-41.8-17v-40h-31c-3.3 0-6.5-1.4-8.8-3.9l-89.8-97.2 38.1-41.3 79.8 86.3H384v-48c0-21.4 26.7-32.1 41.8-17l79.2 71c9.3 9.6 9.3 24.8 0 34.2zM12 152h91.8l79.8 86.3 38.1-41.3-89.8-97.2c-2.3-2.5-5.5-3.9-8.8-3.9H12c-6.6 0-12 5.4-12 12v32c0 6.7 5.4 12.1 12 12.1zm493-41.9l-79.2-71C410.7 24 384 34.7 384 56v40h-31c-3.3 0-6.5 1.4-8.8 3.9L103.8 360H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h111c3.3 0 6.5-1.4 8.8-3.9L372.2 152H384v48c0 21.4 26.7 32.1 41.8 17l79.2-73c9.3-9.4 9.3-24.6 0-33.9z" class=""></path></svg>';
                    }
                };

            })(Editor);

            return Editor;
        }());


    var Autocomplete = (function () {

        var Autocomplete = function () {
            this.version = '1.0.0'
        }

        Autocomplete.prototype = {

            inserted: function (el, binding) {
                var editor = new Editor(el, binding.value),
                    medium = new Medium({
                        element: editor.element(),
                        mode: Medium.richMode,
                        placeholder: (el.getAttribute('placeholder') || ''),
                        attributes: null,
                        tags: null,
                        // tags: {
                        //     'break': 'br',
                        //     'horizontalRule': 'div',
                        //     'outerLevel': ['ul', 'li', 'div'],
                        //     'innerLevel': ['ul', 'li', 'div'],
                        // },
                        pasteAsText: false,
                        onBlur: function () {
                            var value = editor.value().slice(); // copy textContent

                            // simple clear text
                            value = value.replace(/&nbsp;/g, ' ');
                            value = value.replace(/<p><\/p>/g, '').trim();

                            // set the cleaning value to the original element
                            editor.originalElement.value = value

                            // applay change
                            utils.triggerEvent(editor.originalElement, 'input');

                        },
                    });

                editor.setParent(medium);
                el.editor = editor;
            },

            update: function (el, binding) {
                el.editor.value(el.value);
                if (binding.value) {
                    el.editor.toolbar.setOptions(binding.value);
                    el.editor.toolbar.load();
                }
            },
        };

        return Autocomplete;

    }());


    // load internal style
    utils.addStyle();

    return new Autocomplete;

})(window, document);
